// extracted by mini-css-extract-plugin
module.exports = {"text":"ContactOptionIngress_text__MRgn_"};